import BaseInfoBox from "../BaseInfoBox";
import HTPThirdPart from "../HTPThirdPart";


export default class HTPMatchToSameInfo extends BaseInfoBox {
  private HTPThirdPart = HTPThirdPart.getInstance();
  constructor() {
    super();
    this._addCoord()
    this.addBg(260, 130, 0xac0c41, 0xbf1f5e);
    this.addText("MATCH THE SAME CREATURES FOR PRIZES!!", 65, 240);
    this.addToCon();
    this.scale.set(this.startScale);
  }
  _addCoord(){
    let x = -450;
    let y = 0;
    if (this.isVertical) {
      x = -130;
      y = 335
    }
    this.addCoord(x, y);
  }
  addToCon() {
    this.HTPThirdPart.addChild(this);
  }
}